import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=34e96341&scoped=true"
import script from "./createTemplate.vue?vue&type=script&lang=js"
export * from "./createTemplate.vue?vue&type=script&lang=js"
import style0 from "./createTemplate.vue?vue&type=style&index=0&id=34e96341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e96341",
  null
  
)

export default component.exports